// @module Ames.CustomMerchantZone.CustomMerchantZone
define("CustomMerchantZone.MoreItems.View", [
  "custommerchantzone_more_items.tpl",

  "Backbone",

  "CustomMerchantZone.Confirmation.View",

  "Utils",

  "Ames.CustomMerchantZone.CustomMerchantZone.SS2Model",
  "Item.Model",
], function (
  custommerchantzone_more_items_tpl,
  Backbone,
  CustomMerchantZoneConfirmationView,
  Utils,
  CustomMerchantZoneSS2Model,
  ItemModel
) {
  "use strict";

  return Backbone.View.extend({
    template: custommerchantzone_more_items_tpl,

    // how many per page
    itemsPerPage: 24,
    // start on page 1
    currentPage: 1,

    initialize: function initialize(options) {
      this.commerceCategory = Utils.getParameterByName(
        window.location.href,
        "commerceCategory"
      );

      this.application = options.application;

      this.itemModel = new ItemModel();
      this.model = new CustomMerchantZoneSS2Model();

      this.cart = this.application.getComponent("Cart");

      this.catTitle = "";
      this.items = [];
      var self = this;
      if (this.commerceCategory) {
        this.model
          .fetch({
            data: {
              commerceCategory: self.commerceCategory || "",
            },
          })
          .done(function (resp) {
            var internalIds = _.map(resp.data.categoryResults, function (item) {
              return item.internalid;
            });
            // Create mapping of internalid to sequenceNumber
            var sequenceMap = {};
            _.each(resp.data.categoryResults, function (item) {
              sequenceMap[Number(item.internalid)] =
                Number(item.sequenceNumber) || 0;
            });
            self.catTitle = resp.data.name;

            self.itemModel
              .fetch({
                data: {
                  id: internalIds.join(","),
                },
              })
              .done(function (resp) {
                self.items = _.map(resp.items, function (item) {
                  return {
                    id: item.itemid,
                    internalid: item.internalid,
                    name: item.storedisplayname2 || item.displayname,
                    isConfigurable: !!item.custitem_option1description,
                    thumbnail:
                      item.custitem_item_image_full ||
                      "https://www.all-wall.com/scs/img/no_image_available.jpg",
                    url: item.urlcomponent,
                    priceformatted:
                      item.onlinecustomerprice_detail &&
                      item.onlinecustomerprice_detail
                        .onlinecustomerprice_formatted,
                    price:
                      item.onlinecustomerprice_detail &&
                      item.onlinecustomerprice_detail.onlinecustomerprice,
                  };
                });

                // Sort items by sequence number from sequenceMap
                self.items = _.sortBy(self.items, function (item) {
                  return sequenceMap[item.internalid] || 0;
                });

                self.items = self.items.reverse();

                self.totalPages =
                  Math.ceil(self.items.length / self.itemsPerPage) || 1;
                // reset to first page if out of range
                if (self.currentPage > self.totalPages) {
                  self.currentPage = self.totalPages;
                }
                self.render();
              });
          });
      }
      // var cmsitems = settings.custrecord_merchant_items.split("\u0005");
      // this.commerceCategory = settings.custrecord_commerce_category || "";
      // this.orderItems = settings.custrecord_order_items_selection.split("\n");
      // this.title = settings.custrecord_merchant_title || "";
      // this.originalItems = [];
      // this.cart = this.application.getComponent("Cart");
      // this.items = [];
    },

    render: function () {
      // call the base render
      this._render();
      // ensure handlers are bound to the fresh DOM
      this._attachSwipeHandlers();
      return this;
    },

    events: {
      'click [data-action="add-to-cart-custom"]': "addItemToCart",
      'click [data-action="go-to-page"]': "goToPage",
      'click [data-action="prev-page"]': "prevPage",
      'click [data-action="next-page"]': "nextPage",
      'change [data-action="change-items-per-page"]': "changeItemsPerPage",
    },

    changeItemsPerPage: function (e) {
      e.preventDefault();
      // get the value from the select
      var itemsPerPage = parseInt(jQuery(e.target).val(), 10);
      if (itemsPerPage && itemsPerPage !== this.itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        this.currentPage = 1; // reset to first page

        this.totalPages = Math.ceil(this.items.length / this.itemsPerPage) || 1;
        // reset to first page if out of range
        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
        }
        this.render();
      }
    },

    addItemToCart: function (e) {
      /* unchanged */
      e.preventDefault();
      var internalid = jQuery(e.target).data("item-id");
      var self = this;
      this.cart
        .addLine({
          line: {
            quantity: 1,
            item: { internalid: internalid },
          },
        })
        .then(function () {
          var item = _.find(self.items, function (item) {
            return item.internalid === internalid;
          });
          self.cart.getLines().then(function (lines) {
            var line = _.find(lines, function (line) {
              return line.item.internalid === internalid;
            });
            if (line) {
              item.quantity = line.quantity;
            }
            var updateView = new CustomMerchantZoneConfirmationView({
              application: self.application,
              item: item,
            });

            self.application.getLayout().showInModal(updateView);
          });
        });
    },

    // Jump to a specific page
    goToPage: function (e) {
      e.preventDefault();
      var page = parseInt(jQuery(e.target).data("page"), 10);
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.render();
        // scroll to top of zone?
      }
    },

    prevPage: function (e) {
      e.preventDefault();
      if (this.currentPage > 1) {
        this.currentPage--;
        this.render();
      }
    },

    nextPage: function (e) {
      e.preventDefault();
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.render();
      }
    },

    getContext: function getContext() {
      // compute slice
      var start = (this.currentPage - 1) * this.itemsPerPage;
      var end = start + this.itemsPerPage;
      var pageItems = this.items.slice(start, end);

      // === begin pagination window logic ===
      var maxToShow = 5; // <-- maximum links you want visible
      var total = this.totalPages;
      var current = this.currentPage;
      var nums = [];

      if (total <= maxToShow) {
        // if few pages, just list them all
        for (var i = 1; i <= total; i++) {
          nums.push(i);
        }
      } else {
        // always show page 1
        nums.push(1);

        if (current <= maxToShow - 1) {
          // near the start → show pages 2..maxToShow
          for (var i = 2; i <= maxToShow; i++) {
            nums.push(i);
          }
        } else if (current > total - (maxToShow - 1)) {
          // near the end → show the last maxToShow pages
          for (var i = total - (maxToShow - 1); i <= total; i++) {
            nums.push(i);
          }
        } else {
          // middle → show current..current+(maxToShow-2)
          // e.g. at current=5 → pushes 5,6,7,8
          for (var i = current; i <= current + (maxToShow - 2); i++) {
            nums.push(i);
          }
        }
      }

      // build the final pages array your template expects
      var pages = _.map(nums, function (p) {
        return {
          page: p,
          isCurrent: p === current,
        };
      });
      // === end pagination window logic ===

      return {
        title: this.title,
        items: pageItems,
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        hasPrev: this.currentPage > 1,
        hasNext: this.currentPage < this.totalPages,
        pages: pages,
        showPagination: this.totalPages > 1,
        twelveSelected: this.itemsPerPage === 12,
        twentyFourSelected: this.itemsPerPage === 24,
        fortyEightSelected: this.itemsPerPage === 48,
        catTitle: this.catTitle,
      };
    },
  });
});
